<template>
    <div class="vue-selected-country">
        <div class="intro" :style="`background-image: url('${selectedCountry.image}');`">
            <h2>{{ selectedCountry.name }}</h2>

            <div class="text" v-html="selectedCountry.introtext"></div>
        </div>

        <div class="specialisms">
            <h3>{{ selectedCountryHelpTitle }}</h3>

            <zoa-specialism-tabs
                :tabs="selectedCountry.specialisms"
            ></zoa-specialism-tabs>

            <div class="btn-wrapper">
                <a :href="selectedCountry.url" class="btn btn-primary">{{ readMoreAboutText }} {{ selectedCountry.name }}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectedCountry",

    props: ['selectedCountry', 'readMoreAbout', 'selectedCountryHelpTitle'],

    computed: {
        readMoreAboutText() {
            if (_.isNil(this.selectedCountry.more_about)) {
                return this.readMoreAbout;
            }

            return this.selectedCountry.more_about;
        }
    }
}
</script>